<!-- DiscountsList.svelte -->
<script>
    import { createEventDispatcher } from 'svelte';
    import { isIngredientSelected } from '../store.js';
    
    export let discounts = [];
    
    const dispatch = createEventDispatcher();
    
    function selectItem(item) {
      dispatch('selectItem', item);
    }
    
    function formatPrice(price) {
      return price.toFixed(2).replace('.', ',');
    }
    
    function calculateSavings(original, discount) {
      if (original && discount) {
        return formatPrice(original - discount);
      }
      return "0,00";
    }

    // Sort discounts by discount percentage (highest first)
    $: sortedDiscounts = [...discounts].sort((a, b) => b.discount - a.discount);
</script>
  
<div class="discounts-list">
  {#if discounts.length === 0}
    <p class="no-items">Inga varor hittades</p>
  {:else}
    <div class="grid">
      {#each sortedDiscounts as item}
        <div 
          class="discount-card" 
          class:selected={isIngredientSelected(item)}
          on:click={() => selectItem(item)}
        >
          <div class="discount-badge" class:hidden={!item.discount || item.discount === 0}>-{item.discount}%</div>
          <div class="image-container">
            <div class="placeholder-image">{item.name.charAt(0)}</div>
          </div>
          <div class="card-content">
            <h3>{item.name}</h3>
            <p class="description">{item.description}</p>
            <div class="price-container">
              {#if item.originalPrice > 0}
                <span class="original-price">{formatPrice(item.originalPrice)} kr</span>
              {/if}
              <span class="discount-price">{formatPrice(item.discountPrice)} kr</span>
              <span class="unit">/{item.unit}</span>
            </div>
            {#if item.originalPrice > 0}
              <div class="savings">Du sparar: {calculateSavings(item.originalPrice, item.discountPrice)} kr</div>
            {/if}
          </div>
          <div class="select-button-container">
            <button 
              class="select-button" 
              class:selected={isIngredientSelected(item)}
            >
              {isIngredientSelected(item) ? 'Avmarkera' : 'Välj'}
            </button>
          </div>
        </div>
      {/each}
    </div>
  {/if}
</div>
  
<style>
  .discounts-list {
    width: 100%;
  }
  
  .grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 20px;
  }
  
  .discount-card {
    border: 1px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    transition: transform 0.2s, box-shadow 0.2s;
    background-color: white;
    cursor: pointer;
    display: flex;
    flex-direction: column;
  }
  
  .discount-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }
  
  .discount-card.selected {
    border: 2px solid #e91e63;
    box-shadow: 0 5px 15px rgba(233, 30, 99, 0.2);
  }
  
  .discount-badge {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: #e91e63;
    color: white;
    padding: 5px 10px;
    border-radius: 15px;
    font-weight: bold;
    font-size: 14px;
    z-index: 1;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
  
  .discount-badge.hidden {
    display: none;
  }
  
  .image-container {
    height: 150px;
    background-color: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .placeholder-image {
    width: 80px;
    height: 80px;
    background-color: #ddd;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 36px;
    color: #333;
    font-weight: bold;
  }
  
  .card-content {
    padding: 15px;
    flex-grow: 1;
  }
  
  h3 {
    margin: 0 0 10px 0;
    font-size: 18px;
    color: #333;
  }
  
  .description {
    color: #666;
    margin-bottom: 15px;
    font-size: 14px;
    min-height: 40px;
  }
  
  .price-container {
    display: flex;
    align-items: baseline;
    margin-bottom: 5px;
  }
  
  .original-price {
    text-decoration: line-through;
    color: #999;
    margin-right: 10px;
    font-size: 14px;
  }
  
  .discount-price {
    font-weight: bold;
    color: #e91e63;
    font-size: 20px;
  }
  
  .unit {
    color: #666;
    margin-left: 5px;
  }
  
  .savings {
    font-size: 14px;
    color: #4caf50;
    margin-bottom: 15px;
  }
  
  .select-button-container {
    margin-top: auto;
  }
  
  .select-button {
    width: 100%;
    padding: 12px;
    background-color: #f5f5f5;
    border: none;
    border-top: 1px solid #ddd;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.2s, color 0.2s;
  }
  
  .select-button:hover {
    background-color: #eee;
  }
  
  .select-button.selected {
    background-color: #e91e63;
    color: white;
  }
  
  .no-items {
    text-align: center;
    padding: 20px;
    color: #666;
    background-color: #f9f9f9;
    border-radius: 8px;
    border: 1px dashed #ddd;
  }
</style>